import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";


import zuzLogo from '../../assets/images/zuz-logo-filled-text.png';
import zuzLogoFilledNo from '../../assets/images/zuz-logo-filled-no.png';
import netOverlay from '../../assets/images/net-overlay.png';
import pyramid from '../../assets/images/pyramid.png';
import funnel from '../../assets/images/geyser-glow.png';
import Ethereum from '../../assets/images/ethereum.png';
import MetaMask from '../../assets/images/meta-mask.png';

import {StatChart} from '../Charts/index';

import ChainCircle, { RightArrow, RefreshLogo, Tick, EthereumIcon } from '../Svg/index';

import styles from './stylesheets/TokenStats.module.css';

export class TokenStats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenRateInDollar: 4.21,
            tokenRateInEthereum: 0.042,
            totalTokensInCirculation: 11978,
            totalSupply: 11138,
            registeredAddresses: 1337,
            verifiedAddresses: 419,
            verifiedAddressesList: [
                'One addresses', 'One addresses', 
                'Another addresses', 'One addresses',
                'Another addresses', 'One addresses',
                'One addresses', 'One addresses', 
                'Another addresses', 'One addresses',
                'Another addresses', 'One addresses',
                'One addresses', 'One addresses', 
                'Another addresses', 'One addresses',
                'Another addresses', 'One addresses',
                'One addresses', 'One addresses', 
                'Another addresses', 'One addresses',
                'Another addresses', 'One addresses' 
            ]
        }
    }



    signIn = () => {
        alert('sign in ');
    }

    render() {
        return (
            <div className={styles.tokenStats}>
                <div className={styles.statsPageHeading}>
                    <h2>Token Stats</h2>
                    {
                        this.props.isRegisteredUser ? 
                        null:
                        <div className={styles.signInCont}>
                            <a onClick={this.signIn}>SIGN IN</a>
                        </div>
                    }
                    
                </div>

                <div className={styles.tokenStatsSections}>
                    <div className={styles.tokenStatsSection1}>
                        <div className={styles.dollarToEthereumExchanger}>
                            <p>CURRENT TOKEN RATE</p>
                            <div className={styles.dollarToEth}>
                                <div className={styles.dollar}>
                                    <div className={styles.dollarSign}>
                                        $
                                    </div>
                                    <div className={styles.dollarAmount}>
                                        {
                                            this.state.tokenRateInDollar
                                        }
                                        <span>
                                            USD
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.dollar}>
                                    <div className={styles.ethSign}>
                                        <EthereumIcon></EthereumIcon>
                                    </div>
                                    <div className={styles.dollarAmount}>
                                        {
                                            this.state.tokenRateInEthereum
                                        }
                                        <span>
                                            ETH
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.totalTokensBox}>
                            <div className={styles.totalTokens}>
                                <p>
                                    TOTAL TOKENS IN CIRCULATION
                                </p>
                                <div className={styles.value}>
                                    {
                                        this.state.totalTokensInCirculation
                                    }
                                </div>
                            </div>
                            <div className={styles.totalSupply}>
                                <p>
                                    TOTAL SUPPLY
                                </p>
                                <div className={styles.value}>
                                    {
                                        this.state.totalSupply
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.tokenStatsSection2}>
                        <div className={styles.addressesBox}>
                            <div className={styles.left}>
                                <div>
                                    <p>Registered Addresses</p>
                                </div>
                                <div className={styles.value}>
                                    {
                                        this.state.registeredAddresses
                                    }
                                </div>
                            </div>


                            <div className={styles.right}>
                                <div>
                                    <p>Verified Addresses</p>
                                </div>
                                <div className={styles.value}>
                                    {
                                        this.state.verifiedAddresses
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={styles.piChart}>
                            <div className={styles.innerPiChart} style={{'transform': 'rotateZ(107deg)'}}>
                                <StatChart></StatChart>
                            </div>
                        </div>
                        <span className={styles.ratioInChart}>
                            <span>6</span>
                            :
                            <span>4</span>
                        </span>
                    </div>
                    <div className={styles.tokenStatsSection3}>
                    </div>
                </div>








                <div className={styles.tokenStatsSection1} style={{'alignItems': 'flex-end'}}>

                    <div className={styles.totalTokensBox}>
                        <div className={styles.totalTokens}>
                            <p>
                                TOP VERIFIED ADDRESSES
                                </p>
                            <div className={styles.value}>
                                {
                                    this.state.totalTokensInCirculation
                                }
                            </div>
                        </div>
                        <div className={styles.totalSupply}>
                            <p>
                                TOTAL SUPPLY
                                </p>
                            <div className={styles.value}>
                                {
                                    this.state.totalSupply
                                }
                            </div>
                        </div>
                    </div>

                    <div className={styles.dollarToEthereumExchanger} style={{'height': '200px'}}>
                        <p className={styles.para}>TOP VERIFIED ADDRESSES</p>
                        <div className={styles.dollarToEth}>
                            {
                                this.state.verifiedAddressesList.map((address, index)=>(
                                    <div className={styles.addressesContainer}>
                                        <p>
                                        {
                                            address
                                        }
                                        <span className={styles.tickIcon}>
                                            <Tick></Tick>
                                        </span>
                                        </p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default TokenStats
